<mat-nav-list>
    <vsc-menu-item
        icon="house"
        path="/home"
        basePath="/home"
        title="Home"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Homepage.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="book"
        [path]="PagePaths.Public.Classes"
        [basePath]="PagePaths.Public.Classes"
        title="Live Programs"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Classes.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="atlas"
        [path]="PagePaths.Public.ClassLibrary"
        [basePath]="PagePaths.Public.ClassLibrary"
        title="Recorded Programs"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Classes.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="clapperboard-play"
        [path]="PagePaths.Public.VideoLibrary"
        [basePath]="PagePaths.Public.VideoLibrary"
        title="Channels"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Videos.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="calendar-lines"
        path="/calendar"
        basePath="/calendar"
        title="My Calendar"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Calendar.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="message-dots"
        path="/chats"
        basePath="/chats"
        title="Chat"
        class="chat-menu-item"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        [note]="chatInvitesCountNote$ | async"
        *ngxPermissionsOnly="Permissions.Chat.View"
    >
    </vsc-menu-item>
    <vsc-menu-item
        icon="window"
        path="/internet"
        basePath="/internet"
        title="Internet"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Internet.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="newspaper"
        path="/news"
        basePath="/news"
        title="News"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.News.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="sun-cloud"
        path="/weather"
        basePath="/weather"
        title="Weather"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Weather.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="gamepad-modern"
        path="/games"
        basePath="/games"
        title="Games"
        [menuState]="menuState"
        (menuItemClick)="onMenuItemClick()"
        *ngxPermissionsOnly="Permissions.Internet.View"
    ></vsc-menu-item>
    <vsc-menu-item
        icon="envelope"
        title="Gmail"
        [menuState]="menuState"
        (menuItemClick)="openMail()"
    ></vsc-menu-item>
</mat-nav-list>
